import { EngagementLevel, EngagementLevels, capitalize } from 'model';

/**
 * Get descriptive text for an EngagementLevel
 * @param { EngagementLevel } level EngagementLevel to get the description for
 * @returns { string } description of the passed in EngagementLevel
 */
export function getEngagementLevelDescription(level: EngagementLevel): string {
	switch (level) {
		case 'none':
			return 'No engagement feedback will be shown.';
		case 'medium':
			return 'Show engagement with posts by showing like count and read count. Show engagement with comments by displaying like count.';
		case 'high':
			return 'Show engagement with posts by showing like count and read count. Show engagement with comments by displaying like count. Receive notifications when users like your posts or comments.';
	}
}

/**
 * Get the set of engagement level options
 * @returns { Record<EngagementLevel, string> } an object suitable for usage by a Select component
 */
export function getEngagementLevelsOptions() {
	return EngagementLevels.reduce((accum, level) => ({ ...accum, [level]: capitalize(level) }), {});
}

/**
 * Get the markdown text for engagement help
 * @returns { string } the markdown text for the engagement help dialog
 */
export function getEngagementHelpMarkdownText(): string {
	return [
		'# Engagement Feedback\n The engagement feedback preference allows you to control how much engagement feedback you will see.',
		...EngagementLevels.map(level => `#### ${capitalize(level)}\n${getEngagementLevelDescription(level)}`)
	].join('\n\n');
}
